import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import copyText from '../service/clipboard';
import shareTargets from '../service/shareTargets';
export default class ShareMenu extends Component {
  openTarget(event, target) {
    event.preventDefault();

    // Отдельное небольшое окно сохраняет место чтения и не передаёт новой вкладке доступ к opener.
    window.open(target.url, 'devconnect-share', 'noopener,noreferrer,width=720,height=620');
    event.currentTarget.closest('details')?.removeAttribute('open');
  }
  async copy(event) {
    event.preventDefault();
    try {
      await copyText(this.attrs.data.url);
      app.alerts.show({
        type: 'success'
      }, 'Ссылка скопирована.');
    } catch (error) {
      app.alerts.show({
        type: 'error'
      }, 'Не удалось скопировать ссылку.');
    }
    event.currentTarget.closest('details')?.removeAttribute('open');
  }
  view() {
    const targets = shareTargets(this.attrs.data);
    return m('details.dc-share-menu', [m('summary.dc-reading-action', [m('i.fas.fa-share-nodes', {
      'aria-hidden': 'true'
    }), 'Поделиться']), m('div.dc-share-menu__panel', {
      role: 'menu',
      'aria-label': 'Поделиться материалом'
    }, [...targets.map(target => m('a.dc-share-menu__item', {
      className: `dc-share-menu__item--${target.key}`,
      href: target.url,
      target: '_blank',
      rel: 'noopener noreferrer nofollow',
      role: 'menuitem',
      onclick: event => this.openTarget(event, target)
    }, target.label)), m('button.dc-share-menu__item.dc-share-menu__item--copy', {
      type: 'button',
      role: 'menuitem',
      onclick: this.copy.bind(this)
    }, 'Ссылка')])]);
  }
}
flarum.reg.add('devconnect-articles', 'forum/components/ShareMenu', ShareMenu);